import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { FeatureCard, FeatureCardProps } from '../../cards/FeatureCard';
import styles from './FeatureCardGrid.module.scss';

interface FeatureCardGridProps {
  /** Array of feature card configurations to render in the grid */
  readonly cards: ReadonlyArray<FeatureCardProps>;
  /** Optional additional CSS class name */
  readonly className?: string;
  /** Optional test id for testing */
  readonly testId?: string;
}

/**
 * FeatureCardGrid component that displays a responsive grid of FeatureCard components.
 *
 * This component takes an array of feature card configurations and renders them
 * in a responsive grid layout. The responsive behavior is handled by individual
 * FeatureCard components which adapt to different screen sizes.
 *
 * @param props - The component props
 * @returns The rendered feature card grid component
 */
const FeatureCardGridComponent: React.FC<Readonly<FeatureCardGridProps>> = ({ cards, className, testId }) => {
  return (
    <Box className={`${styles.gridContainer} ${className ?? ''}`} data-testid={testId}>
      <Grid container spacing={1.7} className={styles.cardGrid}>
        {cards.map((cardProps, index) => (
          <FeatureCard key={cardProps.testId ?? `feature-card-${index}`} {...cardProps} />
        ))}
      </Grid>
    </Box>
  );
};

export const FeatureCardGrid = React.memo(FeatureCardGridComponent);
